module.exports = __webpack_public_path__ + "img/hr-brown-fluff-09.2456abe3.png";